import {
    SET_CASH_TRANSACTIONS,
    SET_ERROR,
    CLEAR_ERROR,
    SET_QUESTIONS,
    STOP_LOADING,
    SET_LOADING
   } from "./types";
   
   import AdminService from "../../services/admin.service";





   export const addCashInvestment = (data) => (dispatch) => {
    dispatch({
        type: CLEAR_ERROR,
      });
    return AdminService.addCashInvestment(data).then(
      (response) => {
        return dispatch(getCashTransactions())
      },
      (error) => {
        dispatch({
          type: SET_ERROR,
        });
        return [];
      }
    );
  };


  export const getCashTransactions =  () => (dispatch) => {
    console.log('getAdmins')
   dispatch({
       type: CLEAR_ERROR,
     });
   return AdminService.getCashTransactions().then(
     (response) => {
       console.log(response)
       return   dispatch({
        type: SET_CASH_TRANSACTIONS,
        payload: response
      });
     },
     (error) => {
       console.log(error)
       dispatch({
         type: SET_ERROR,
       });
       return [];
     }
   );
 };



   export const getAdmins =  () => (dispatch) => {
     console.log('getAdmins')
    dispatch({
        type: CLEAR_ERROR,
      });
    return AdminService.getAdmins().then(
      (response) => {
        console.log(response)
        return response;
      },
      (error) => {
        console.log(error)
        dispatch({
          type: SET_ERROR,
        });
        return [];
      }
    );
  };



 
   export const uploadImage = (data) => (dispatch) => {
     dispatch({
         type: CLEAR_ERROR,
       });
     return AdminService.uploadImage(data).then(
       (response) => {
         return response.url;
       },
       (error) => {
         dispatch({
           type: SET_ERROR,
         });
         return Promise.reject();
       }
     );
   };


    
   export const addQuestion = (data) => (dispatch) => {
     console.log(data)
    dispatch({
        type: SET_LOADING,
      });
    return AdminService.addQuestion(data).then(
      (response) => {
        console.log(response)
        dispatch({
          type: STOP_LOADING,
        });
        return response
      },
      (error) => {
        console.log(error)

        dispatch({
          type: SET_ERROR,
        });
        dispatch({
          type: STOP_LOADING,
        });
        return Promise.reject();
      }
    );
  };


   
  export const addFollowup = (data) => (dispatch) => {
    dispatch({
      type: SET_LOADING,
    });
    return AdminService.addFollowup(data).then(
      (response) => {
        dispatch({
          type: STOP_LOADING,
        });
        return response.url;
      },
      (error) => {
        dispatch({
          type: SET_ERROR,
        });
        dispatch({
          type: STOP_LOADING,
        });
        return Promise.reject();
      }
    );
  };


  export const getQuestions = () => (dispatch) => {
    dispatch({
      type: SET_LOADING,
    });
    return AdminService.getQuestions().then(
      (response) => {
         dispatch({
          type: SET_QUESTIONS,
          payload: response
        });
        dispatch({
          type: STOP_LOADING,
        });
        return;
      },
      (error) => {
        dispatch({
          type: SET_ERROR,
        });
        dispatch({
          type: STOP_LOADING,
        });
        return Promise.reject();
      }
    );
  };

  export const copyQuestion = (data) => (dispatch) => {
    dispatch({
      type: SET_LOADING,
    });
    return AdminService.copyQuestion(data).then(
      (response) => {
        dispatch({
          type: STOP_LOADING,
        });
        return;
      },
      (error) => {
        dispatch({
          type: SET_ERROR,
        });
        dispatch({
          type: STOP_LOADING,
        });
        return Promise.reject();
      }
    );
  };

  export const deleteQuestion = (data) => (dispatch) => {
    dispatch({
      type: SET_LOADING,
    });
    return AdminService.deleteQuestion(data).then(
      (response) => {
        dispatch({
          type: STOP_LOADING,
        });
        return;
      },
      (error) => {
        dispatch({
          type: SET_ERROR,
        });
        dispatch({
          type: STOP_LOADING,
        });
        return Promise.reject();
      }
    );
  };
   
  